import { Position } from "../types";

/**
 * scroll the window so that it is centered at a specified position
 */
export default function centerAt(position: Position) {
  const sx = position.x - 0.5 * innerWidth;
  const sy = position.y - 0.5 * innerHeight;

  window.scroll(sx, sy);
}
